import { render, staticRenderFns } from "./LandingBabyRegistryPT.vue?vue&type=template&id=79ed7a92&scoped=true"
import script from "./LandingBabyRegistryPT.vue?vue&type=script&lang=js"
export * from "./LandingBabyRegistryPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ed7a92",
  null
  
)

export default component.exports